import React from 'react';
import QuestionFeedback from './QuestionFeedback';
import './question-feedback.css';

/**
 * QuestionEvaluationCard — question feedback inside a chat reply (REQ-005, FE-5-2/5-3)
 * Location: frontend/src/components/question-evaluator/QuestionEvaluationCard.js
 *
 * Renders the `question_evaluation` / `question_evaluation_status` pair that
 * POST /report-ai/evaluate returns (CONTRACTS.md → REQ-005). `ok` shows the
 * shared QuestionFeedback card, display-only (no switch button, D-4/D-5);
 * every other status is a one-line notice and the rest of the reply still shows.
 */

const STATUS_TEXT = {
  empty: 'Add your question to get feedback on it.',
  too_long: 'Your question is too long to score — keep it under 2,000 characters.',
  failed: "Your question couldn't be evaluated this time. The rest of the feedback is below.",
};

const TYPE_LABELS = {
  key_decision: 'Key Decision',
  knowledge_gap: 'Knowledge Gap',
};

const QuestionEvaluationCard = ({ status, result, type }) => {
  if (!status) return null;

  const label = TYPE_LABELS[type] || TYPE_LABELS.key_decision;
  const showResult = status === 'ok' && result;

  return (
    <section className="question-eval-card" aria-label={`${label} question feedback`}>
      <span className="qec-title">Your {label} question</span>
      {showResult ? (
        <QuestionFeedback result={result} type={type} />
      ) : (
        <p className={`qec-status ${status === 'failed' || !STATUS_TEXT[status] ? 'qec-status-failed' : ''}`}>
          {STATUS_TEXT[status] || STATUS_TEXT.failed}
        </p>
      )}
    </section>
  );
};

export default QuestionEvaluationCard;
